import { DayPicker, NavigationNext, NavigationPrevious } from './styles'

DayPicker.NavigationNext = NavigationNext
DayPicker.NavigationPrevious = NavigationPrevious

export default DayPicker
